__turbopack_context__.v({
  "checkmark": "Checkbox-module__-933IW__checkmark",
  "inputWrapper": "Checkbox-module__-933IW__inputWrapper",
  "label": "Checkbox-module__-933IW__label",
  "textError": "Checkbox-module__-933IW__textError",
});
